import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { base64Decode, isDefinedNotEmpty } from '@softline/core';
import { SettingsService } from './services/settings.service';

export const settingsResolver: ResolveFn<void> = (route) => {
  const settingService = inject(SettingsService);
  try {
    const encoded = route.queryParamMap.get('settings');
    if (!encoded) return;

    const data = JSON.parse(base64Decode(encoded));
    if (isDefinedNotEmpty(data)) {
      settingService.save(data);
    }
    return;
  } catch (e) {
    console.error('Failed to parse route data', e);
    return;
  }
};
